import { Modal, Spin, Row, message } from 'antd';
import { Formik } from 'formik';
import { Input } from 'formik-antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormControl from '~/components/Form/FormControl';
import { ModalFooter } from '~/components/Modal';
import { createExpenses, updateExpenses } from '~/services/hooks/expenses';
import { useCheckAuth } from '~/components/Can/checkAuth';
import errorHandler from '~/Utils/errorHandler';

const initial = {
  name: null,
};

export default function ExpensesModal({ visible, onClose, expensesEdit, isMobile }) {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(initial);

  const handleSave = async (values, { setErrors }) => {
    setLoading(true);
    try {
      if (expensesEdit?.id) {
        await updateExpenses(expensesEdit.id, values);
        message.success(t('Despesa atualizada'));
      } else {
        await createExpenses(values);
        message.success(t('Despesa criada'));
      }
      onClose();
    } catch (error) {
      console.error(error);
      setErrors(errorHandler(error));
    }
    setLoading(false);
  };

  const fluidPermissions = () => {
    if (expensesEdit) {
      return authCheck('@eventsExpenses/edit');
    } else {
      return authCheck('@eventsExpenses/create');
    }
  };

  useEffect(() => {
    if (visible) {
      if (expensesEdit) {
        setInitialValues(expensesEdit);
      }
    }
  }, [visible]);

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSave}
    >
      {({ isSubmitting, submitForm, values }) => (
        <Modal
          title={(expensesEdit ? t('Editando despesa - ') : t('Criando despesa - ')) + (values.name ?? '')}
          onCancel={onClose}
          afterClose={() => setInitialValues(initial)}
          open={visible}
          centered
          width={isMobile ? '100%' : '800px'}
          footer={<ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={onClose} />}
        >
          <Spin spinning={loading}>
            <Row>
              <FormControl cols={{ xs: 24 }} label={t('fields:name')} field="name">
                <Input disabled={!fluidPermissions()} name="name" placeholder={t('Nome')} />
              </FormControl>
            </Row>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
